import { useFlags } from "launchdarkly-react-client-sdk";

import { useAgentsEnabledFlag } from "./use-agents-enabled-flag";

/**
 * Whether the agents opt-out experience is enabled for this user.
 *
 * Gated on BOTH the `aiFeaturesSettings` LaunchDarkly flag and the agents tier
 * (`useAgentsEnabledFlag`): the org-level AI feature settings (implicit opt-in
 * with explicit opt-out) only apply once agents are actually available. When
 * this is true we surface the AI features settings and suppress the legacy
 * agents ToS opt-in.
 */
export const useAgentsOptOutEnabled = (): boolean => {
  const { aiFeaturesSettings } = useFlags();
  const isAgentsEnabled = useAgentsEnabledFlag();

  return Boolean(aiFeaturesSettings) && isAgentsEnabled;
};
